import { motion, useReducedMotion } from 'motion/react'

interface ProgressTrackProps {
  progress: number  // 0-100
}

export function ProgressTrack({ progress }: ProgressTrackProps) {
  const reducedMotion = useReducedMotion()
  const scaleX = progress / 100

  return (
    <div
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Document processing progress"
      style={{
        width: '100%',
        height: '3px',
        borderRadius: 'var(--radius-full)',
        background: 'var(--upload-progress-track)',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <motion.div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'var(--gradient-action)',
          borderRadius: 'var(--radius-full)',
          transformOrigin: 'left center',
          scaleX,
        }}
        animate={{ scaleX }}
        transition={
          reducedMotion
            ? { duration: 0 }
            : { duration: 0.4, ease: [0.4, 0, 0.2, 1] }
        }
      />
    </div>
  )
}
